<template>
    <main class="chapter-page">
        <SliceZone :components="components" :slices="chapter?.data?.slices ?? []" />
    </main>
</template>
<script setup lang="ts">
    import {SliceZone} from '@prismicio/vue';
    import type {TrendsDocument} from '@prismicio-types';
    import {useRoute} from '@typed-router';
    import {useAsyncData, useHead, useRequestURL, useSeoMeta, useWebsitePageView} from '#imports';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {useResolvePrismicDocument} from '~/composables/content/useResolvePrismicDocument';
    import {components} from '~/slices/components';

    const {
        params: {uid},
    } = useRoute('resources-trends-uid-uid');

    const {data, error} = await useAsyncData(`trends-chapter-${uid}`, () => usePrismicDocument<TrendsDocument>('trendsChapter', uid as string));
    const chapter = useResolvePrismicDocument(data, error);

    if (chapter.value) {
        useSeoMeta({
            title: chapter.value.data.metaTitle ?? '',
            description: chapter.value.data.metaDescription ?? '',
            robots: chapter.value.data.noIndex ? 'noindex' : 'index',
            ogImage: chapter.value.data.openGraphImage?.url ?? '',
            ogTitle: chapter.value.data.openGraphTitle ?? '',
            ogDescription: chapter.value.data.openGraphDescription ?? '',
        });
    }

    const {origin, pathname} = useRequestURL();
    const canonicalUrl = `${origin}${pathname}`;
    useHead({link: [{rel: 'canonical', href: canonicalUrl}]});

    useWebsitePageView('resources-center', 'trends');
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .chapter-page {
        .slice-content {
            text-align: left;
            position: relative;
            max-width: calc(1180px + 2 * var(--joy-core-spacing-9));
        }
    }
</style>
